import { createRequest } from "helpers/tools";

export const editSourceByConnectionId = async (connection_id, data) => {
    return await createRequest({
        suffix: `lead/connection/${connection_id}/sources/edit`,
        method: "post",
        payload: data,
        handleError: false,
    });
};
